import { FlowRoute } from './types'

export const signupCoreContinue = ({ partner }) => {
  // If not registering through partner, push to bank linking
  if (!partner) {
    return FlowRoute.Funding
  }

  // Conditionally determine where to go next based on the
  // data that the partner has provided us with
  const { user } = partner

  if (!user.firstName || !user.lastName || !user.dob) {
    return FlowRoute.PersonalInfo
  } else if (!user.ssn) {
    return FlowRoute.SSN
  } else if (!user.address1 || !user.city || !user.state || !user.zip || !user.phoneNumber) {
    return FlowRoute.ContactInfo
  } else {
    return FlowRoute.InvestInterstitial
  }
}

export const institutionsCoreSkip = (_, { visitedPages }: any) => {
  if (
    visitedPages.some(
      (path: string) =>
        path === FlowRoute.SecondChanceBankLink ||
        path === FlowRoute.RecurringInvestment ||
        path === FlowRoute.OneTimeInvestment,
    )
  ) {
    return FlowRoute.Success
  }

  return FlowRoute.PricingInterstitial
}

export const bankLinkSuccessCoreContinue = (_, { visitedPages, roundUpsEnabled }: any) => {
  if (visitedPages.includes(FlowRoute.SecondChanceBankLink)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.RecurringInvestment
  } else if (visitedPages.includes(FlowRoute.RecurringInvestment)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.RecurringInvestment
  } else if (visitedPages.includes(FlowRoute.OneTimeInvestment)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.OneTimeInvestment
  } else {
    return FlowRoute.PricingInterstitial
  }
}

export const portfolioContinue = ({ fundingSource, roundUpsEnabled }) => {
  if (!fundingSource) {
    return FlowRoute.SecondChanceBankLink
  } else {
    if (roundUpsEnabled) {
      return FlowRoute.RoundUpsInterstitial
    } else {
      return FlowRoute.RecurringInvestment
    }
  }
}

export const portfolioTieredContinue = ({ fundingSource, isEligibleRoundUps }) => {
  if (!fundingSource) {
    return FlowRoute.SecondChanceBankLink
  } else {
    if (isEligibleRoundUps) {
      return FlowRoute.RoundUpsInterstitial
    } else {
      return FlowRoute.RecurringInvestment
    }
  }
}

export const portfolioLaterContinue = ({ roundUpsEnabled }) => {
  if (roundUpsEnabled) {
    return FlowRoute.RoundUpsInterstitial
  } else {
    return FlowRoute.RecurringInvestment
  }
}

export const startInvestingCoreNext = ({ referralDisclosureRequired }) => {
  return referralDisclosureRequired ? FlowRoute.ReferralReward : FlowRoute.Success
}

export const spendPersonalInfoContinue = (_, { visitedPages }) => {
  if (visitedPages.some((path: string) => path === FlowRoute.SpendOrderConfirmation)) {
    return FlowRoute.SpendOrderConfirmation
  } else {
    return FlowRoute.PersonalInfo
  }
}
